import { getToken, redirectToCmsLogin } from "..";
import { ApiBase } from "../Network";

async function readJson(response) {
    try {
        return await response.json();
    } catch (e) {
        return {};
    }
}

function handleUnauthorized(response) {
    if (response.status === 401) {
        redirectToCmsLogin();
        return true;
    }
    return false;
}


export class HttpService {

    async get(url,body)  {
        // this.setHeaders();
        var headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json");   
        const auth = getToken();

        if (auth) headers.append("Authorization", "Bearer " + auth);   


        const response = await fetch(`${ApiBase}${url}`, {
        headers: new Headers(headers),
        method: 'GET',
        });

        const data = await readJson(response);
        if (handleUnauthorized(response)) return {};

        return data;
    }

    async post(url,body,hasFile)  {
        var headers = new Headers();
        if(!hasFile)
            headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = getToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   
        
        const response = await fetch(`${ApiBase}${url}`, {
            headers: new Headers(headers),
            method: 'POST',
            body: hasFile ? body : JSON.stringify(body),
        });



        const data = await readJson(response);
        if (handleUnauthorized(response)) return {};

        console.log(data)

        return data;
    }

    async put(url,body,hasFile=false)  {
        var headers = new Headers();
        if(!hasFile)
            headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = getToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   
        
        const response = await fetch(`${ApiBase}${url}`, {
            headers: new Headers(headers),
            method: 'PUT',
            body: hasFile ? body : JSON.stringify(body),
        });

        const data = await readJson(response);
        if (handleUnauthorized(response)) return {};

        console.log(body)
        console.log(data)

        return data;
    }

    async patch(url,body,hasFile)  {
        
        var headers = new Headers();
        if(!hasFile)
            headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = getToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   
        
        const response = await fetch(`${ApiBase}${url}`, {
            headers: new Headers(headers),
            method: 'PATCH',
            body: JSON.stringify(body),
        });

        const data = await readJson(response);
        if (handleUnauthorized(response)) return {};

        return data;
    }

    async delete(url) {
        var headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = getToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   

        const response = await fetch(`${ApiBase}${url}`, {
        headers: new Headers(headers),
        method: 'DELETE',
        });

        handleUnauthorized(response);
        return ;
    }

    

    
}

